import React from 'react';
import {
  AiOutlineArrowRight,
  AiOutlineCode,
  AiOutlineRocket,
  AiOutlineStar,
} from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { Carousel } from '../../../ui';
import './HeroSections.css';

const HeroSection2 = () => {
  const navigate = useNavigate();

  const slides = [
    {
      id: 1,
      title: 'Premium Project Templates',
      subtitle: 'Ready-to-Deploy Solutions',
      description:
        'Get access to production-ready projects with complete source code, documentation, and deployment guides.',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      icon: <AiOutlineCode />,
      image: '🎯',
    },
    {
      id: 2,
      title: 'Full Stack Projects',
      subtitle: 'React + .NET Powered',
      description:
        'Modern web applications built with React frontend and powerful .NET backend architecture.',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      icon: <AiOutlineRocket />,
      image: '🚀',
    },
    {
      id: 3,
      title: 'Student Special',
      subtitle: 'Perfect for Academic Projects',
      description:
        'College-ready projects with detailed documentation, PPT presentations, and video tutorials.',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      icon: <AiOutlineStar />,
      image: '⭐',
    },
  ];

  return (
    <div className="hero-section-2">
      <Carousel
        autoplay
        autoplaySpeed={5000}
        effect="fade"
        className="hero-2-carousel"
      >
        {slides.map((slide, index) => (
          <div key={slide.id}>
            <div
              className="hero-2-slide"
              style={{ background: slide.gradient }}
            >
              <div className="hero-2-particles">
                {[...Array(20)].map((_, i) => (
                  <div
                    key={i}
                    className="hero-2-particle"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      animationDelay: `${Math.random() * 5}s`,
                      animationDuration: `${5 + Math.random() * 10}s`,
                    }}
                  />
                ))}
              </div>

              <div className="hero-2-content">
                <div className="hero-2-text-content">
                  <div className="hero-2-icon-wrapper" data-aos="zoom-in">
                    <span className="hero-2-emoji-icon">{slide.image}</span>
                  </div>

                  <h1 className="hero-2-title" data-aos="fade-up">
                    {slide.title}
                  </h1>

                  <h1
                    className="hero-2-subtitle"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    {slide.subtitle}
                  </h1>

                  <span
                    className="hero-2-description"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    {slide.description}
                  </span>

                  <div
                    className="hero-2-buttons"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <button
                      type="button"
                      className="btn btn-primary btn-lg hero-2-btn"
                      onClick={() => navigate('/products')}
                    >
                      <AiOutlineArrowRight /> Browse Projects
                    </button>
                    <button
                      type="button"
                      className="btn btn-lg hero-2-btn-outline"
                      onClick={() => navigate('/about')}
                    >
                      Learn More
                    </button>
                  </div>
                </div>

                <div className="hero-2-features">
                  <div
                    className="hero-2-feature"
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    <div className="hero-2-feature-icon">✓</div>
                    <span>Complete Source Code</span>
                  </div>
                  <div
                    className="hero-2-feature"
                    data-aos="fade-right"
                    data-aos-delay="500"
                  >
                    <div className="hero-2-feature-icon">✓</div>
                    <span>Documentation Included</span>
                  </div>
                  <div
                    className="hero-2-feature"
                    data-aos="fade-right"
                    data-aos-delay="600"
                  >
                    <div className="hero-2-feature-icon">✓</div>
                    <span>Lifetime Updates</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default HeroSection2;
